import Swiper from "swiper/bundle";

export default class Carousel {
  constructor(element) {
    this.element = element;
    this.defaultOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
      loopAdditionalSlides: 2,
      loop: false,
      pagination: {
        el: this.element.querySelector(".swiper-pagination"),
        type: "bullets"
      },
      navigation: {
        nextEl: this.element.querySelector(".custom-next"),
        prevEl: this.element.querySelector(".custom-prev")
      }
    };
    this.spaceBetween = { spaceBetween: 24 };
    this.applyNavigation();
    this.init();
  }

  updateCounter(swiper) {
    const parent = this.element.closest('.container') || this.element.parentElement;
    const counterEl = parent?.querySelector('.swiper-counter');
    if (!counterEl) return;
    const total = this.element.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    counterEl.textContent = `${swiper.realIndex + 1}/${total}`;
  }

  resizeSlides() {
    const slides = this.element.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    const applyResize = () => {
      slides.forEach(slide => slide.style.height = 'auto');
      const maxHeight = Math.max(...Array.from(slides).map(slide => slide.offsetHeight));
      slides.forEach(slide => slide.style.height = `${maxHeight}px`);
    };

    // Attendre que les images soient chargées
    const images = this.element.querySelectorAll('img');
    if (images.length) {
      let loaded = 0;
      images.forEach(img => {
        if (img.complete) {
          loaded++;
          if (loaded === images.length) applyResize();
        } else {
          img.addEventListener('load', () => {
            loaded++;
            if (loaded === images.length) applyResize();
          });
        }
      });
    } else {
      applyResize();
    }
  }

  applyNavigation() {
    const parent = this.element.closest('.container');
    const customNext = parent?.querySelector('.custom-next');
    const customPrev = parent?.querySelector('.custom-prev');
    if (customNext && customPrev) {
      this.defaultOptions.navigation.nextEl = customNext;
      this.defaultOptions.navigation.prevEl = customPrev;
    } else {
      this.defaultOptions.navigation.nextEl = this.element.querySelector('.swiper-button-next');
      this.defaultOptions.navigation.prevEl = this.element.querySelector('.swiper-button-prev');
    }
  }

  init() {
    let options = this.defaultOptions;

    const commonOn = {
      init: (swiper) => {
        this.resizeSlides();
        this.updateCounter(swiper);
        window.addEventListener('resize', () => this.resizeSlides());
      },
      slideChange: (swiper) => this.updateCounter(swiper)
    };

    switch (this.element.dataset.carousel) {
      case "one":
        options = {
          ...this.defaultOptions,
          slidesPerView: 1,
          on: commonOn
        };
        break;
      case "two":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          loop: true,
          slidesPerView: 1,
          breakpoints: { 768: { slidesPerView: 2 } },
          on: commonOn
        };
        break;
      case "three":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          loop: false,
          slidesPerView: 1,
          544: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          on: commonOn
        };
        break;
      case "four":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          slidesPerView: 1,
          breakpoints: {
            544: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1200: { slidesPerView: 4 }
          },
          on: commonOn
        };
        break;
      case "five":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          slidesPerView: 1,
          breakpoints: {
            544: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
            1200: { slidesPerView: 5 }
          },
          on: commonOn
        };
        break;
      case "six":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          slidesPerView: 1,
          breakpoints: {
            544: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
            1100: { slidesPerView: 5 },
            1300: { slidesPerView: 6 }
          },
          on: commonOn
        };
        break;
      case "footer":
        options = {
          ...this.defaultOptions,
          ...this.spaceBetween,
          slidesPerView: 1,
          breakpoints: {
            544: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
            1400: { slidesPerView: 6 },
            1600: { slidesPerView: 7 },
            1800: { slidesPerView: 8 }
          },
          autoplay: { delay: 3000 },
          on: commonOn
        };
        break;
    }

    new Swiper(this.element, options);
  }
}
